import { sendRawRequest } from "@api/clients/axios";
import { type NotificationMetadata, notificationMetadataSchema } from "@repo/types";
import { queryOptions } from "@tanstack/react-query";

export type NotificationItem = {
  id: number;
  createdAt: Date;
  title: string;
  content: string;
  channel: string;
  status: string;
  metadata: NotificationMetadata;
  read_at: Date | null;
};

type NotifierListResponse = {
  data: Record<string, unknown>[];
  totalPages?: number;
  total?: number;
};

export const NOTIFICATION_PAGE_SIZE = 10;

export function notificationPageQueryOptions(notifierId: number, page: number) {
  return queryOptions({
    queryKey: ["notifications", notifierId, page] as const,
    queryFn: async () => {
      const response = await sendRawRequest<undefined, NotifierListResponse>(
        "get",
        "notifier",
        undefined,
        { params: { page, pageSize: NOTIFICATION_PAGE_SIZE } }
      );
      const items = response.data.data ?? [];
      return {
        items: items.map(
          (notification): NotificationItem => ({
            id: Number(notification.id),
            createdAt: new Date(String(notification.createdAt)),
            read_at: notification.read_at ? new Date(String(notification.read_at)) : null,
            title: String(notification.title ?? ""),
            content: String(notification.content ?? ""),
            channel: String(notification.channel ?? ""),
            status: String(notification.status ?? ""),
            metadata: notificationMetadataSchema.parse(notification.metadata ?? {}),
          })
        ),
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
      };
    },
    staleTime: 30_000,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
}

export async function markNotificationRead(id: number): Promise<void> {
  await sendRawRequest<number[], unknown>("put", "notifier/read", [id]);
}
